<template>
    <ContentOrLoading>
        <MainContent title="Editar campo" v-if="!loading">
            <template v-slot:header>
                <h3 class="card-title">Editar campo</h3>
            </template>
            <template v-slot:content>
                <FormComponent :campo="campo" @terminado="editarCampo()" @recargar="recargar()" :key="reloadComponent"/>
            </template>
        </MainContent>
    </ContentOrLoading>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/formularios/FormComponent';

    export default {
        props: ['field_id'],
        data() {
            return {
                loading: false,
                campo: null,
                reloadComponent: 1
            }
        },
        methods: {
            getField() {
                this.loading = true;

                const params = {
                    filters : {},
                    teatro_id: this.teatro.id,
                    field_id: this.field_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.forms.field'), params).then(res => {
                    this.campo = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            editarCampo() {
                this.loading = true;
                this.campo.field_id = this.campo.id;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.forms.editar'), this.campo).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.formularios.index' });
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                }).finally(() => {
                    this.loading = false;
                });
            },
            recargar() {
                this.reloadComponent += 1;
            },
        },
        created() {
            this.getField();
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>